import { render, staticRenderFns } from "./PProcessInfoForm.vue?vue&type=template&id=6c3fad42&"
import script from "./PProcessInfoForm.vue?vue&type=script&lang=js&"
export * from "./PProcessInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports